'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppAuthData$ForOrgMember$$anon$2() {
}
export { $c_Lapp_data_AppAuthData$ForOrgMember$$anon$2 as $c_Lapp_data_AppAuthData$ForOrgMember$$anon$2 };
$p = $c_Lapp_data_AppAuthData$ForOrgMember$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppAuthData$ForOrgMember$$anon$2;
/** @constructor */
function $h_Lapp_data_AppAuthData$ForOrgMember$$anon$2() {
}
export { $h_Lapp_data_AppAuthData$ForOrgMember$$anon$2 as $h_Lapp_data_AppAuthData$ForOrgMember$$anon$2 };
$h_Lapp_data_AppAuthData$ForOrgMember$$anon$2.prototype = $p;
$p.ak = (function(src) {
  return src;
});
var $d_Lapp_data_AppAuthData$ForOrgMember$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppAuthData$ForOrgMember$$anon$2, "app.data.AppAuthData$ForOrgMember$$anon$2", ({
  zb: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_data_AppAuthData$ForOrgMember$$anon$2 as $d_Lapp_data_AppAuthData$ForOrgMember$$anon$2 };
//# sourceMappingURL=app.data.-App-Auth-Data$-For-Org-Member$$anon$2.js.map
